import { Button, Css, useModal, useSnackbar } from "@homebound/beam";
import { useTriggerQaDatabaseResetMutation } from "src/routes/admin/infrastructure/Infrastructure.generated";
import { ConfirmationModal } from "src/routes/components/ConfirmationModal";
import { PageHeader } from "src/routes/layout/PageHeader";

export function InfrastructurePage() {
  const { openModal } = useModal();
  const { triggerNotice } = useSnackbar();
  const [triggerReset, { loading }] = useTriggerQaDatabaseResetMutation();
  return (
    <>
      <PageHeader title="QA Database" />
      <div css={Css.df.fdc.gap2.p3.maxw("640px").$}>
        <p css={Css.sm.gray700.$}>
          Force-redeploys the QA database and service to pull the latest sanitized-from-prod snapshot. The full reset
          (database restart, schema migration, and service redeploy) takes approximately 15 minutes.
        </p>
        <div>
          <Button
            label="Sync from prod"
            onClick={() =>
              openModal({
                content: (
                  <ConfirmationModal
                    title="Sync QA from prod"
                    label="Yes, sync now"
                    danger
                    confirmationMessage={`This will reset the QA database from the latest production snapshot. Everyone working in QA
             will lose their session and any unsaved test data. The environment will be unavailable for
             approximately 15 minutes. Continue?`}
                    onConfirmAction={async () => {
                      const { data } = await triggerReset();
                      const result = data?.triggerQaDatabaseReset;
                      if (result?.message) {
                        triggerNotice({ message: result.message });
                      }
                    }}
                  />
                ),
              })
            }
            disabled={loading}
          />
        </div>
      </div>
    </>
  );
}
